import view from 'bundle-text:../dom/privacyPolicy.html'; // eslint-disable-line
import app from './app';

export default () => {
  const content = document.createElement('div');

  content.classList.add(
    'align-items-center',
    'd-flex',
    'justify-content-center',
    'w-100',
  );
  content.innerHTML = view;

  document.title = `${app.run.settings.view.privacyPolicy.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  return content;
};
